import { Box, Card, Grid, Typography } from "@mui/material";
import * as React from "react";
import { useGetOne } from "react-admin";
import { Link } from "react-router-dom";
const DailyQuickLinkBox = () => {
  const [record, setRecord] = React.useState();
  const [load, setLoad] = React.useState(true);
  const { data, isLoading, error } = useGetOne("total/quicklinkBox", { id: 1 });
  React.useEffect(() => {
    if (data) {
      setRecord(data?.total || {});
      setLoad(false);
    }
  }, [data]);

  // if (isLoading) {
  //   return <div>Loading...</div>;
  // }
  // if (!record) {
  //   return <div>Loading...</div>;
  // }

  const quickLinkData = [
    {
      title: "Pending Screening",
      // count: record?.pendingScreening,
      count: load ? "" : record?.pendingScreening,
      link: '/applications?filter={"status":"Ready for Review"}',
    },
    {
      title: "Pending Initial Review",
      count: load ? "" : record?.pendingInitialReview,
      link: '/applications?filter={"status":"Initial Review"}',
    },
    {
      title: "Pending Final Review",
      count: load ? "" : record?.pendingFinalReview,
      link: '/applications?filter={"status":"Final Review"}',
    },
    {
      title: "Pre-Approval & Counter Offer Accepted",
      count: load ? "" : record?.preApprovalAccepted,
      link: '/applications?filter={"status":"CounteredAndPreApproved","subStatus":"Offer Accepted"}',
    },
    // {
    //   title: "Counter Offer Accepted",
    //   count: record?.counterOfferAccepted,
    //   link: '/applications?filter={"status":"CounteredAndPreApproved","subStatus":"Offer Accepted"}',
    // },
    {
      title: "Ready for Notification",
      count: load ? "" : record?.readyForNotification,
      link: '/applications?filter={"status":"To Notify"}',
    },
    {
      title: "Pending Disbursement",
      count: load ? "" : record?.pendingDisbursement,
      link: '/applications?filter={"status":"Approved","subStatus":"Signature Completed"}',
    },
  ];
  const quickLoanLinkData = [
    {
      title: "Funding Source Removed",
      count: load ? "" : record?.fundingSourceRemoved,
      link: '/loans?filter={"status":"active","curStatus":"Funding Source Removed"}',
    },
    // {
    //   title: "ACH Transfer Failed",
    //   count: load ? "" : record?.transferFailed,
    //   link: '/achpayment?filter={"status":"120-Day Failed ACH"}',
    // },
    {
      title: "Paid-Off with Credit Balance",
      count: load ? "" : record?.paidOff_creditBalance,
      link: '/loans?filter={"status":"Paid-Off","curStatus":"creditBalance"}',
    },
    {
      title: "> 30Day Delinquent",
      count: load ? "" : record?.large30D,
      link: '/loans?filter={"status":"active","curStatus":"large30D"}',
    },
  ];
  return (
    <>
      <Card
        sx={{
          height: "450px",
          marginBottom: "20px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          flex: "1",
          "& a": {
            textDecoration: "none",
            color: "inherit",
          },
          borderRadius: "0px",
        }}
        id="daily-quick-link-box"
      >
        <Typography
          variant="body2"
          id="applications-review-tasks-title"
          sx={{
            ml: 2,
            mt: 2,
            fontWeight: "bold",
            fontSize: "16px",
            color: "grey",
          }}
        >
          Applications Review Tasks
        </Typography>
        <Grid
          container
          spacing={1}
          // id="grid-quick-link-applications"
          sx={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "16px",
            padding: "16px",
            marginLeft: "0px",
            marginTop: "0px",
          }}
          id="dashboard-quicklink-application"
        >
          {quickLinkData &&
            quickLinkData.map((item, index) => (
              <Grid
                item
                key={index}
                sx={{
                  width: "100%",
                  "&.MuiGrid-item": { padding: "0px" },
                }}
              >
                <Link to={item.link}>
                  <Box
                    sx={{
                      width: "100%",
                      // height: "100%",
                      height: "91px",
                      marginTop: "0px",
                      marginLeft: "0px",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#ffdb9d30",
                      borderRadius: "8px",
                      padding: "16px",
                      "&:hover": {
                        backgroundColor: "#ffdb9d60",
                      },
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: "10px",
                        color: "#1976d2",
                        fontSize: "0.875rem",
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      variant="h4"
                      sx={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: "10px",
                        fontSize: "0.875rem",
                      }}
                      className="numericText"
                    >
                      {item.count}
                    </Typography>
                  </Box>
                </Link>
              </Grid>
            ))}
        </Grid>
        <Typography
          variant="body2"
          sx={{
            ml: 2,
            mt: 1,
            fontWeight: "bold",
            fontSize: "16px",
            color: "grey",
          }}
        >
          Loans Management Tasks
        </Typography>
        <Grid
          container
          spacing={1}
          sx={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "16px",
            padding: "16px",
            marginLeft: "0px",
            marginTop: "0px",
          }}
          id="dashboard-quicklink-loans"
        >
          {quickLoanLinkData &&
            quickLoanLinkData.map((item, index) => (
              <Grid
                item
                key={index}
                sx={{
                  width: "100%",
                  "&.MuiGrid-item": { padding: "0px" },
                }}
              >
                <Link to={item.link}>
                  <Box
                    sx={{
                      width: "100%",
                      // height: "100%",
                      height: "91px",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#ffdb9d30",
                      borderRadius: "8px",
                      padding: "16px",
                      "&:hover": {
                        backgroundColor: "#ffdb9d60",
                      },
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: "10px",
                        color: "#1976d2",
                        fontSize: "0.875rem",
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      variant="h4"
                      sx={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: "10px",
                        fontSize: "0.875rem",
                      }}
                      className="numericText"
                    >
                      {item.count}
                    </Typography>
                  </Box>
                </Link>
              </Grid>
            ))}
        </Grid>
      </Card>
    </>
  );
};

export default DailyQuickLinkBox;
